/** @file Vuex store module for user UI preferences such as font size and diff context amount. */
import { getStoreBuilder } from '@codegrade/vuex-typex';
import * as utils from '@/utils';
const storeBuilder = getStoreBuilder();
/** @returns A fresh default preference state. */
const makeInitialState = () => ({
    fontSize: 12,
    contextAmount: 3,
});
const moduleBuilder = storeBuilder.module('pref', makeInitialState());
/** The store for user UI preferences. */
export var PreferenceStore;
(function (PreferenceStore) {
    /** Getter for the current font size. */
    PreferenceStore.fontSize = moduleBuilder.read(state => state.fontSize, 'fontSize');
    /** Getter for the current diff context amount. */
    PreferenceStore.contextAmount = moduleBuilder.read(state => state.contextAmount, 'contextAmount');
    /** Sets the font size used in code viewers. */
    PreferenceStore.setFontSize = moduleBuilder.commit((state, newFontSize) => {
        state.fontSize = newFontSize;
    }, 'setFontSize');
    /** Sets the number of unchanged context lines shown around diffs. */
    PreferenceStore.setContextAmount = moduleBuilder.commit((state, newContextAmount) => {
        state.contextAmount = newContextAmount;
    }, 'setContextAmount');
    /** Resets the preference state to its initial values. */
    PreferenceStore.commitClearAll = moduleBuilder.commit(state => Object.assign(state, makeInitialState()), 'commitClearAll');
    utils.signal.AFTER_USER_CHANGED.registerSync(() => {
        PreferenceStore.commitClearAll();
    });
})(PreferenceStore || (PreferenceStore = {}));
